import { CSSProperties, type JSX } from "react";
import { Link } from "react-router-dom";
import {
  CloseButton,
  Header,
  LeftContainer,
  MiddleContainer,
  RightContainer,
  Subtitle,
  SubtitleContainer,
  VerticalDivider,
} from "./__styles__/HeaderNav";
import Icon, { ICON_COLORS, Icons } from "./Icons";

type HeaderNavProps = {
  subtitle?: string;
  prevLocation?: { pathname: string; search?: string } | string;
  rightContainer?: JSX.Element;
  middleContainer?: JSX.Element;
  style?: CSSProperties;
  onClose?: () => void;
  dark?: boolean;
};

const HeaderNav = ({
  subtitle,
  prevLocation,
  rightContainer,
  middleContainer,
  onClose,
  dark,
  ...props
}: HeaderNavProps) => {
  let closeButton = null;

  if (onClose) {
    closeButton = (
      <CloseButton onClick={onClose}>
        <Icon
          icon={Icons.CLOSE}
          color={dark ? ICON_COLORS.WHITE : ICON_COLORS.GREY}
          hoverable
        />
      </CloseButton>
    );
  }

  if (prevLocation) {
    closeButton = (
      <CloseButton>
        <Link to={prevLocation}>
          <Icon
            icon={Icons.CLOSE}
            color={dark ? ICON_COLORS.WHITE : ICON_COLORS.GREY}
            hoverable
          />
        </Link>
      </CloseButton>
    );
  }

  return (
    <Header aria-label="Page Header" {...props} dark={dark}>
      <LeftContainer>
        {closeButton}
        {subtitle && (
          <SubtitleContainer>
            <VerticalDivider />
            <Subtitle>{subtitle}</Subtitle>
          </SubtitleContainer>
        )}
      </LeftContainer>
      {middleContainer && <MiddleContainer>{middleContainer}</MiddleContainer>}
      <RightContainer>{rightContainer}</RightContainer>
    </Header>
  );
};

export default HeaderNav;
